import { Environment } from '@dice/app/types/env.type';
import { DEV_1_ENV_CONFIG } from '@dice/environments/dev/dev-1.env';
import { DEV_2_ENV_CONFIG } from '@dice/environments/dev/dev-2.env';
import { DEV_BLUE_ENV_CONFIG } from '@dice/environments/dev/dev-blue.env';
import { DEV_GREEN_ENV_CONFIG } from '@dice/environments/dev/dev-green.env';
import { DEV_MASTERDATA_ENV_CONFIG } from '@dice/environments/dev/dev-masterdata.env';
import { DEV_STABLE_ENV_CONFIG } from '@dice/environments/dev/dev-stable.env';
import { INT_1_ENV_CONFIG } from '@dice/environments/int/int-1.env';
import { INT_2_ENV_CONFIG } from '@dice/environments/int/int-2.env';
import { INT_BLUE_ENV_CONFIG } from '@dice/environments/int/int-blue.env';
import { INT_GREEN_ENV_CONFIG } from '@dice/environments/int/int-green.env';
import { INT_MASTERDATA_ENV_CONFIG } from '@dice/environments/int/int-masterdata.env';
import { INT_STABLE_ENV_CONFIG } from '@dice/environments/int/int-stable.env';
import { LOCAL_ENV_CONFIG } from '@dice/environments/local/local.env';
import { MOCK_ENV_CONFIG } from '@dice/environments/local/mock.env';
import { PROD_ENV_CONFIG } from '@dice/environments/prod/prod.env';
import { PROD_BLUE_ENV_CONFIG } from '@dice/environments/prod/prod-blue.env';
import { PROD_GREEN_ENV_CONFIG } from '@dice/environments/prod/prod-green.env';
import { PROD_MASTERDATA_ENV_CONFIG } from '@dice/environments/prod/prod-masterdata.env';

enum ENV {
  mock = 'mock',
  local = 'local',
  devStable = 'dev',
  dev1 = 'dev-1',
  dev2 = 'dev-2',
  devGreen = 'dev-green',
  devBlue = 'dev-blue',
  devMasterdata = 'dev-masterdata',
  intStable = 'int',
  int1 = 'int-1',
  int2 = 'int-2',
  intBlue = 'int-blue',
  intGreen = 'int-green',
  intMasterdata = 'int-masterdata',
  prod = 'prod',
  prodGreen = 'prod-green',
  prodBlue = 'prod-blue',
  prodMasterdata = 'prod-masterdata',
}

const ENVIRONMENTS: Record<ENV, Environment> = {
  [ENV.mock]: MOCK_ENV_CONFIG,
  [ENV.local]: LOCAL_ENV_CONFIG,
  [ENV.devStable]: DEV_STABLE_ENV_CONFIG,
  [ENV.dev1]: DEV_1_ENV_CONFIG,
  [ENV.dev2]: DEV_2_ENV_CONFIG,
  [ENV.devBlue]: DEV_BLUE_ENV_CONFIG,
  [ENV.devGreen]: DEV_GREEN_ENV_CONFIG,
  [ENV.devMasterdata]: DEV_MASTERDATA_ENV_CONFIG,
  [ENV.intStable]: INT_STABLE_ENV_CONFIG,
  [ENV.int1]: INT_1_ENV_CONFIG,
  [ENV.int2]: INT_2_ENV_CONFIG,
  [ENV.intBlue]: INT_BLUE_ENV_CONFIG,
  [ENV.intGreen]: INT_GREEN_ENV_CONFIG,
  [ENV.intMasterdata]: INT_MASTERDATA_ENV_CONFIG,
  [ENV.prod]: PROD_ENV_CONFIG,
  [ENV.prodGreen]: PROD_GREEN_ENV_CONFIG,
  [ENV.prodBlue]: PROD_BLUE_ENV_CONFIG,
  [ENV.prodMasterdata]: PROD_MASTERDATA_ENV_CONFIG,
};

export class EnvironmentProvider {
  static get environment(): Environment {
    const { host } = window.document.location;
    return Object.values(ENVIRONMENTS).find((env: Environment) => {
      return env.hostNames.indexOf(host) > -1;
    });
  }

  static get isProd(): boolean {
    const currentEnv = EnvironmentProvider.environment;
    return !currentEnv || currentEnv.isProduction;
  }

  static get isLocal(): boolean {
    const { hostname } = window.document.location;
    return (
      hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      !!hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    );
  }
}
